// Thin LOCAL fetch client for the doctor unread-message count (Messages nav badge). New endpoint,
// not in the published DoctorClient — read it raw here (mirrors profileExtrasApi). baseUrl + getToken
// → Bearer, credentials:"include" (dev cookie), { data } unwrap.
import { useMemo } from "react";
import { API_ORIGIN } from "../config";
import { useAppAuth } from "../auth";

export function useUnreadApi(): {
  count(): Promise<number>;
  unreadByPatient(): Promise<Record<string, number>>;
} {
  const { getToken } = useAppAuth();
  return useMemo(() => {
    async function get<T>(path: string): Promise<T | null> {
      const headers: Record<string, string> = {};
      const token = await getToken();
      if (token) headers["Authorization"] = `Bearer ${token}`;
      const res = await fetch(`${API_ORIGIN}${path}`, { method: "GET", headers, credentials: "include" });
      if (!res.ok) return null;
      return ((await res.json()) as { data?: T }).data ?? null;
    }
    return {
      count: () => get<{ unread?: number }>("/v1/doctor/messages/unread-count").then((d) => d?.unread ?? 0),
      // Per-patient unread for the Messages roster (the published patients() schema strips `unread`).
      unreadByPatient: () =>
        get<Array<{ id: string; unread?: number }>>("/v1/doctor/patients").then((rows) => {
          const map: Record<string, number> = {};
          for (const r of rows ?? []) map[r.id] = r.unread ?? 0;
          return map;
        }),
    };
  }, [getToken]);
}
